module.exports = __webpack_public_path__ + "static/ez-hero-desktop-017c32efb93a09163160bc216bd1c024.png";